import React, { FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { cartMobx, discountMobx } from 'restaurant'
import { payPlanMobx, memberMobx, payRechargeMobx, payChannelMobx } from '@mobxStore'
import { format, toDecimal } from '@dt/fe-utils'
import { Icon, McRechargeStall } from '@cps'
import './index.scss'

interface IProps {
  onChange: (show: boolean) => void;
}

const PayAndRechargeList: FC<IProps> = ({ onChange }) => {
  const [memListShow, setMemListShow] = useState(null)
  const isMemberCardPayTip = window.bo !== 'cn' ? memberMobx.cardInfo?.card?.isPayTip : true
  const { rechargeInfo } = payRechargeMobx
  const { discountAction, discountResult } = discountMobx

  const getRechargeList = async () => {
    const memList = await memberMobx.checkMcReStall(memberMobx.cardInfo?.memberCardId, toDecimal(payPlanMobx.totalAmount + cartMobx.cartResult.totalDiscountPrice), payPlanMobx.tipAmount)
    setMemListShow(memList)
    onChange(isMemberCardPayTip && !!memList?.length)
  }

  const handleSetRechargeInfo = async (info: any) => {
    payRechargeMobx.setRechargeInfo(info)
    discountMobx.setMockCardRechargeId(info?.cardRechargeId)
    setTimeout(() => {
      !!discountMobx.discountResult.mockRechargeUseCouponMoreOff && discountMobx.setMockCardRechargeUseCoupon(!discountAction.mockCardRechargeUseCoupon)
    })
  }

  const handleCleanRechargeInfo = async () => {
    payRechargeMobx.setRechargeInfo()
    discountMobx.setMockCardRechargeId()
  }

  useEffect(() => {
    if (memberMobx.cardInfo) {
      getRechargeList()
    }
  }, [memberMobx.cardInfo, payPlanMobx.totalAmount, payPlanMobx.orderAmount, payPlanMobx.tipAmount])

  useEffect(() => {
    if (rechargeInfo && (!memListShow?.length || !memListShow?.find(l => l.cardRechargeId === discountAction.mockCardRechargeId))) {
      handleCleanRechargeInfo()
    }
  }, [memListShow])

  return (
    <>
      {
        isMemberCardPayTip && memListShow?.length && payChannelMobx.availableMemberCardMethod ? (
          <div className='pay-and-recharge-list' id='PayAndRechargeList'>
            <div className='pr-header'>
              <div className='prh-tag'><span>{i18n.t('pay.payAndRecharge.activity')}</span></div>
              <div className='prh-title'>
                {memberMobx.cardInfo?.card?.cardName}
                <span className='balance'>{i18n.t('pay.payAndRecharge.currentBalance', { amount: format.toPrice(memberMobx.cardInfo?.balance || 0) })}</span>
              </div>
            </div>
            <div className='pr-content'>
              <div className='prc-title'>{i18n.t('pay.recharge')}</div>
              <McRechargeStall
                value={rechargeInfo}
                data={memberMobx._memCardList}
                onChange={handleSetRechargeInfo}
              />
              {
                discountResult.onlyBalancePayMoreOff ? (
                  <div className='prc-discount'>
                    <span>{i18n.t('pay.payAndRecharge.useBalance')}</span>
                    <span className='use-reduce' dangerouslySetInnerHTML={{ __html: i18n.t('pay.payAndRecharge.useBalanceReduce', { amount: `<big>${format.toPriceLittleCurrency(discountResult.onlyBalancePayMoreOff)}</big>` }) }}></span>
                  </div>
                ) : null
              }
              {
                discountResult.mockRechargeUseCouponMoreOff ? (
                  <div className='prc-discount' data-cypid='payAndRechargeList' onClick={() => discountMobx.setMockCardRechargeUseCoupon(!discountAction.mockCardRechargeUseCoupon)}>
                    <Icon name={discountAction.mockCardRechargeUseCoupon ? 'checked' : 'circle'} />
                    <span>{i18n.t('pay.payAndRecharge.useCoupon')}</span>
                    <span className='use-reduce' dangerouslySetInnerHTML={{ __html: i18n.t(`pay.payAndRecharge.${discountAction.mockCardRechargeUseCoupon ? 'reudced' : 'reudce'}`, { amount: `<big>${format.toPrice(discountResult.mockRechargeUseCouponMoreOff || 0)}</big>` }) }}></span>
                  </div>
                ) : null
              }
            </div>
          </div>
        ) : null
      }
    </>
  )
}

export default observer(PayAndRechargeList)
